<script setup>
import { useMonitoringGeneralStore } from '@/store/monitoringGeneral';
import { storeToRefs } from 'pinia';

const monitoringStore = useMonitoringGeneralStore();
const { selectDevice } = monitoringStore;
const { devices, currentDevice } = storeToRefs(monitoringStore);

</script>

<template>
  <v-menu>
    <template #activator="{ props }">
      <v-btn
        rounded
        variant="tonal"
        append-icon="mdi-menu"
        class="text-truncate"
        v-bind="props"
        data-testid="select-monitoring-device"
      >
        <slot>
          <span class="text-truncate" style="max-width: 130px">{{ currentDevice?.name }}</span>
        </slot>
      </v-btn>
    </template>
    <v-list selectable>
      <v-list-item
        v-for="(device, index) in devices"
        :key="'monitoring-device-' + index"
        :data-testid="'monitoring-device-' + device.name"
        @click="selectDevice(device)"
      >
        <v-list-item-title class="text-truncate text-uppercase" style="max-width: 150px">
          {{ device.name }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
